export default {
  accept: "Terima",
  accept_work_update: "Terima pembaruan Lagu",
  accepted: "Diterima",
  acquirer: "Pengakuisisi",
  active: "Aktif",
  adaptor: "Pihak pengadaptasi",
  add: "Tambah",
  add_heir: "Tambah Ahli Waris",
  add_interested_party: "tambahkan pihak yang berkepentingan",
  add_licensee: "tambahkan pemegang lisensi",
  add_name: "Tambah Nama",
  add_party: "tambahkan pihak lain",
  add_performer: "Tambah Performer",
  add_title: "Tambah Judul",
  added: "Ditambah",
  added_lyrics: "Lirik yang ditambah",
  additional: "Tambahan",
  additional_names: "Nama Tambahan",
  address: "Alamat",
  administration_costs: "Biaya Admin",
  administrator: "Admin",
  affiliations: "afiliasi",
  agreement: "Agreement",
  agreement_conflict: "konflik agreement",
  agreement_conflicts: "konflik agreement",
  agreement_created: "agreement dibuat",
  agreement_deleted: "agreement dihapus",
  agreement_is_in_conflict: "agreement ini bertentangan dengan agreement lain",
  agreement_is_inactive: "agreement ini tidak dapat diedit karena tidak aktif.",
  agreement_updated: "agreement diperbarui",
  agreements: "agreement",
  agreements_uploads: "unggahan agreement",
  air_date_time: "tanggal dan waktu tayang",
  album: "album",
  allocate: "mengalokasikan",
  allocate_distribution: "mengalokasikan distribusi",
  allocated: "dialokasikan",
  allocating: "mengalokasikan",
  allocation_process_successfully_triggered: "proses alokasi berhasil dipicu",
  alternate_titles: "judul alternatif",
  alternative_title: "judul alternatif",
  amount: "jumlah",
  an_email_with_instructions_for_reset_pass_has_been_sent: "email berisi instruksi untuk mengatur ulang kata sandi Anda telah dikirim",
  and: "dan",
  applied: "diterapkan",
  arrangement: "pengaturan",
  arranger: "Arranger",
  artist: "artis",
  assignee: "penerima tugas",
  assignee_name_search: "assignee name search",
  assignor: "pemberi tugas",
  assignor_name_search: "assignor name search",
  at: "di",
  atlas_id: "ID Atlas",
  author: "Penulis Lirik",
  automatched: "otomatis",
  back: "kembali",
  back_to_distribution: "kembali ke distribusi",
  back_to_distributions: "kembali ke distribusi",
  back_to_login: "kembali ke login",
  back_to_results: "kembali ke hasil",
  bank_amount: "jumlah bank",
  blocked: "diblokir",
  board_member: "anggota dewan",
  bulk_works_upload: "unggah karya massal",
  but: "tapi",
  ca_e_link: "Tautan CA/E",
  cable: "kabel",
  cancel: "membatalkan",
  candidate: "kandidat",
  candidate_matched: "kandidat berhasil dicocokkan",
  candidates: "kandidat",
  chained_to: "dirantai ke",
  changed: "berubah",
  cinema: "bioskop",
  claimed_mec: "diklaim mekanis",
  claimed_per: "diklaim melakukan",
  claimed_total: "total klaim",
  clear_filters: "filter yang jelas",
  clear_selected: "jelas dipilih",
  click_to_select_file_or_drag_and_drop: "klik untuk memilih file atau seret dan lepas",
  close: "tutup",
  close_distribution: "distribusi dekat",
  closed: "ditutup",
  code: "kode",
  collection_date: "tanggal pengumpulan",
  comment: "komentar",
  comment_deleted: "komentar dihapus",
  comment_saved: "komentar disimpan",
  comment_updated: "komentar diperbarui",
  comments: "komentar",
  complete: "lengkap",
  composer: "Komposer",
  concerts: "konser",
  confirm_allocate_distribution: "Anda akan memicu alokasi untuk semua pool dalam distribusi ini. Apakah Anda ingin melanjutkan?",
  confirm_close_distribution: "Setelah ditutup, distribusi dan kumpulannya tidak dapat lagi diedit atau dihapus. Anggota tidak akan diberitahu hingga distribusi diterbitkan.",
  confirm_create_agreement: "Data agreement yang diberikan akan menimbulkan konflik dengan agreement berikut. Apakah Anda tetap ingin membuat agreement ini?",
  confirm_delete_agreement: "apakah Anda benar-benar ingin menghapus agreement ini",
  confirm_delete_comment: "apakah Anda benar-benar ingin menghapus komentar ini",
  confirm_delete_distribution: "Apakah Anda benar-benar ingin menghapus siklus distribusi ini? Semua pengaturan dan alokasi akan hilang. Tindakan ini tidak dapat dibatalkan.",
  confirm_delete_distribution_pool: "apakah Anda benar-benar ingin menghapus kumpulan distribusi ini",
  confirm_delete_exclusion_file: "do you really want to delete this exclusion file",
  confirm_delete_heir: "apakah Anda benar-benar ingin menghapus ahli waris ini",
  confirm_delete_interested_party: "apakah Anda ingin melanjutkan untuk menghapus pihak yang berkepentingan ini",
  confirm_delete_pro_rata_file: "apakah Anda benar-benar ingin menghapus file pro-rata ini",
  confirm_delete_usage_file: "File penggunaan ini dan data terkait akan dihapus. Apakah Anda benar-benar ingin menghapusnya",
  confirm_delete_user: "apakah Anda benar-benar ingin menghapus pengguna ini",
  confirm_delete_works: "apakah Anda benar-benar ingin menghapus lagu ini",
  confirm_demerge_work: "mengkonfirmasi lagu yang muncul",
  confirm_email: "konfirmasi email",
  confirm_generate_crd_report: "Apakah Anda ingin meminta laporan CRD untuk distribusi ini? Anda akan dapat mengunduh laporan saat laporan tersebut dibuat.",
  confirm_member_work_update: "Perubahan Anda akan ditinjau oleh admin komunitas sebelum diterapkan.",
  confirm_publish_distribution: "Tindakan ini membuat laporan distribusi tersedia bagi para anggota. Apakah Anda ingin melanjutkan?",
  confirm_undo_allocation: "Anda ingin membatalkan alokasi? Semua alokasi dalam pool ini akan dihapus.",
  confirm_undo_distribution_allocation: "Apakah anda ingin membatalkan alokasi untuk semua pool dalam distribusi ini? Semua alokasi di pool ini akan dihapus.",
  confirm_unmatch_usage: "apakah Anda benar-benar ingin membatalkan penggunaan ini",
  confirm_update: "konfirmasi pembaruan",
  conflict: "konflik",
  conflict_detected: "konflik terdeteksi",
  conflict_detected_user_action_created: "Konflik telah terdeteksi dan tindakan pengguna telah dibuat",
  conflict_with_existing_work: "data lagu yang Anda berikan bertentangan dengan lagu yang sudah ada, dan tindakan pengguna untuk menyelesaikan konflik ini dibuat",
  conflicting_agreement: "agreement yang bertentangan",
  contact: "kontak",
  contact_name: "nama kontak",
  contact_updated: "data kontak diperbarui",
  continue: "lanjutkan",
  contributor: "kontributor",
  contributor_roles: "peran kontributor",
  contributors: "kontributor",
  copy: "salin",
  copy_configuration_from: "menyalin konfigurasi dari",
  copyright_free: "bebas hak cipta",
  country: "negara",
  crd_files: "File CRD",
  crd_matching: "Pencocokan CRD",
  crd_pool: "Kumpulan CRD",
  crd_reports: "Laporan CRD",
  crd_reports_confirmation: "Konfirmasi Unduh Laporan CRD",
  crd_successfully_matched: "crd berhasil dicocokkan",
  create: "membuat",
  create_agreement: "membuat agreement",
  create_crd_distribution_pool: "membuat kumpulan distribusi CRD",
  create_digital_distribution_pool: "membuat kumpulan distribusi PRONTO",
  create_distribution: "membuat distribusi",
  create_distribution_pool: "membuat kumpulan distribusi",
  create_new_user_for: "membuat pengguna baru untuk",
  create_non_ipi_party: "Buat Partai Non-IPI",
  create_pool: "buat kolam renang",
  create_recording: "membuat rekaman",
  create_vod_distribution_pool: "Membuat kumpulan distribusi VOD",
  create_work: "membuat lagu",
  created: "dibuat",
  created_by: "dibuat oleh",
  creation_date: "tanggal pembuatan",
  currency: "mata uang",
  current: "saat ini",
  date_of_birth: "Tanggal Lahir",
  date_of_death: "Tanggal Kematian",
  dates: "tanggal",
  day: "hari",
  declare_new_work: "mendeklarasikan lagu baru",
  decline: "penurunan",
  decline_work_update: "menolak pembaruan lagu",
  declined: "ditolak",
  deductibles: "deductible",
  delete: "hapus",
  delete_agreement: "hapus agreement",
  delete_distribution: "hapus distribusi",
  delete_distribution_pool: "hapus kumpulan distribusi",
  delete_exclusion_file: "delete exclusion file",
  delete_heir: "hapus ahli waris",
  delete_interested_party: "hapus pihak yang berkepentingan",
  delete_pro_rata_file: "menghapus file saat ini",
  delete_usage_file: "hapus file penggunaan",
  delete_user: "hapus pengguna",
  delete_work: "hapus lagu",
  deleted: "dihapus",
  demerge: "demerge",
  demerge_message: "Sumber berikut ini akan diturunkan dari lagu ini",
  demerged: "demerged",
  demerged_work: "lagu yang diturunkan",
  description: "Deskripsi",
  detach_all_files: "lepaskan semua file",
  detach_file: "lepaskan file",
  detach_sheet: "lepaskan lembar",
  different_spelling: "Ejaan yang berbeda",
  digital_files: "file digital",
  digital_pool: "Kolam renang PRONTO",
  distributable: "dapat didistribusikan",
  distributable_net: "bersih yang dapat didistribusikan",
  distribution: "distribusi",
  distribution_cycles: "distribution cycles",
  distribution_errors: "kesalahan distribusi",
  distribution_pool_successfully_created: "kumpulan distribusi berhasil dibuat",
  distribution_pool_successfully_deleted: "kumpulan distribusi berhasil dihapus",
  distribution_pool_successfully_edited: "kumpulan distribusi berhasil diedit",
  distribution_successfully_closed: "distribusi berhasil ditutup",
  distribution_successfully_created: "distribusi berhasil dibuat",
  distribution_successfully_deleted: "distribusi berhasil dihapus",
  distribution_successfully_edited: "distribusi berhasil diedit",
  distribution_successfully_published: "distribusi berhasil diterbitkan",
  distributions: "distribusi",
  do_you_want_to_accept_this_update: "apakah Anda ingin menerima pembaruan ini",
  do_you_want_to_continue: "Apakah Anda ingin melanjutkan?",
  do_you_want_to_decline_this_update: "apakah Anda ingin menolak pembaruan ini",
  domestic_pool: "kolam renang domestik",
  done: "selesai",
  download_aggregate_member_finance: "download aggregate member finance report",
  download_crd_reports: "unduh laporan CRD",
  download_current_file: "unduh file saat ini",
  download_prorata_file_template: "unduh templat file pro-rata",
  download_qa_reports: "unduh laporan QA",
  download_template: "unduh template",
  download_works_list: "unduh daftar karya lagu",
  dsp: "DSP",
  duplicates_not_allowed: "duplikat tidak diperbolehkan",
  duration: "durasi",
  edit: "sunting",
  edit_crd_distribution_pool: "mengedit kumpulan distribusi CRD",
  edit_digital_distribution_pool: "edit kumpulan distribusi PRONTO",
  edit_distribution: "edit distribusi",
  edit_distribution_pool: "edit kumpulan distribusi",
  edit_shares: "mengedit saham",
  edit_tags: "edit tag",
  edit_vod_distribution_pool: "Edit kumpulan distribusi VOD",
  edit_work: "edit lagu",
  edited: "diedit",
  editing_multiple_tags_warning: "Tag berikut ini akan diterapkan ke semua file yang dipilih. Jika tidak ada tag yang ditentukan, semua tag yang ada akan dihapus dari file.",
  email: "email",
  end: "akhir",
  end_date: "tanggal akhir",
  error: "kesalahan",
  errors: "kesalahan",
  events: "acara",
  exclude: "mengecualikan",
  exclusion_file_deleted: "exclusion file deleted",
  exclusions: "exclusions",
  existing_agreements: "agreement yang ada",
  extra_search_title: "judul pencarian tambahan",
  field: "bidang",
  file_errors: "kesalahan file",
  file_not_attached: "file tidak dilampirkan",
  file_successfully_uploaded: "file berhasil diunggah",
  filename: "nama file",
  files: "file",
  first_line_of_text: "baris pertama teks",
  first_name: "nama depan",
  for: "untuk",
  form_contains_errors: "formulir mengandung kesalahan. mohon verifikasi semua informasi yang diberikan",
  formal_title: "gelar formal",
  from: "dari",
  full_name: "nama lengkap",
  fund_id: "ID dana",
  funds: "dana",
  general: "umum",
  general_users: "pengguna umum",
  generate_UP1_report: "Membuat laporan UP1",
  go_to: "pergi ke",
  go_to_agreement_conflict: "pergi ke konflik agreement",
  go_to_detail_page: "pergi ke halaman detail",
  go_to_user_action: "pergi ke tindakan pengguna",
  go_to_work: "pergi ke lagu",
  go_to_works_matching_user_action: "pergi ke lagu yang sesuai dengan tindakan pengguna",
  gross_amount: "kotor",
  has_files: "memiliki file",
  heir_deleted: "ahli waris dihapus",
  heirs: "ahli waris",
  hide_reviewed: "sembunyikan ditinjau",
  high: "tinggi",
  history: "sejarah",
  holding_reference: "Memegang Referensi",
  inactive: "tidak aktif",
  include: "termasuk",
  include_exclude: "termasuk/tidak termasuk",
  income_participant: "Peserta Pendapatan",
  incoming_work: "lagu yang masuk",
  incomplete: "tidak lengkap",
  incorrect_title: "judul yang salah",
  ingested: "tertelan",
  ingestion_stats: "statistik konsumsi",
  inheritance_start_date: "tanggal warisan",
  interested_parties: "pihak yang berkepentingan",
  interested_party: "pihak yang berkepentingan",
  interested_party_name: "nama pihak yang berkepentingan",
  interested_party_number: "nomor pihak yang berkepentingan",
  invalid_ipi_base_number: "Nomor dasar IPI tidak valid",
  invalid_isrc: "ISRC tidak valid",
  invalid_iswc: "ISWC tidak valid",
  ip_matching_stats: "Statistik pencocokan IP",
  ipi_base_number: "Nomor dasar IPI",
  ipi_information: "Informasi IPI",
  ipi_name_number: "Nomor nama IPI",
  ipi_number: "Nomor IPI",
  ipi_status: "Status IPI",
  ipi_status_1: "IP valid yang direferensikan sendiri",
  ipi_status_2: "Pembelian",
  ipi_status_3: "Penghapusan logis dengan referensi silang",
  ipi_status_4: "Penghapusan logis total tanpa referensi silang",
  isrc: "ISRC",
  iswc: "ISWC",
  item: "item",
  iteration: "iterasi",
  karaoke: "karaoke",
  landed: "mendarat",
  landing_db_ingestion: "pendaratan db konsumsi",
  language: "bahasa",
  last_name: "nama belakang",
  last_run: "lari terakhir",
  latest: "terbaru",
  legal_name: "nama hukum",
  less: "kurang",
  licensee: "pemegang lisensi",
  link: "tautan",
  link_recording: "perekaman tautan",
  linked: "terkait",
  linked_to_existing_work: "karya tersebut telah dikaitkan dengan karya yang sudah ada",
  linked_work: "lagu terkait",
  login: "masuk",
  logout: "keluar",
  low: "rendah",
  lyrical_adaptations: "adaptasi liris",
  mandates: "mandat",
  manually_created: "dibuat secara manual",
  manually_linked: "ditautkan secara manual",
  manually_matched: "dicocokkan secara manual",
  mark_as_reviewed: "tandai sebagai ditinjau",
  marked_for_deletion: "ditandai untuk dihapus",
  match: "cocok",
  matched: "cocok",
  matched_by: "dicocokkan oleh",
  matched_work: "lagu yang cocok",
  matching_stats: "statistik yang cocok",
  mechanical: "mekanis",
  medium: "sedang",
  member: "anggota",
  member_reports: "laporan anggota",
  bulk_member_reports: "laporan seluruh anggota",
  member_reports_download: "unduh laporan distribusi",
  member_reports_processing: "memproses laporan distribusi",
  member_reports_request: "meminta laporan distribusi",
  member_work_matching_message: "Pendaftaran karya ini berpotensi duplikat dan sedang menunggu peninjauan oleh administrator masyarakat Anda.",
  member_work_update_notice: "Anda akan dapat melacak setiap perubahan yang tertunda di tab 'pembaruan lagu' di halaman lagu.",
  membership_status: "status keanggotaan",
  merge: "menggabungkan",
  merge_works: "gabungkan karya",
  merging_more_than_three_works_not_allowed: "penggabungan lebih dari tiga karya tidak diperbolehkan",
  merging_not_allowed_for_non_domestic_works: "penggabungan tidak diperbolehkan untuk lagu non-domestik",
  metadata: "metadata",
  modification: "Modifikasi",
  modified_lyrics: "lirik yang dimodifikasi",
  modified_version: "versi yang dimodifikasi",
  month: "bulan",
  more: "lebih lanjut",
  more_information: "informasi lebih lanjut",
  music_added_to_text: "musik ditambahkan ke teks",
  music_arrangement: "aransemen musik",
  music_video: "video musik",
  my_profile: "profil saya",
  my_works: "karya saya",
  name: "nama",
  name_search: "pencarian nama",
  names: "nama",
  nationalities: "kebangsaan",
  net_distributable_amount: "bersih",
  new_lyrics_added: "lirik baru ditambahkan",
  new_music_added: "musik baru ditambahkan",
  new_work_created: "sebuah karya baru berhasil dibuat",
  no: "tidak",
  no_chained_shares: "tidak ada saham yang dirantai",
  no_crd_reports: "Laporan CRD tidak tersedia",
  no_distribution_reports_for_member: "Anda tidak berhak atas pembayaran apa pun dalam siklus distribusi ini, sehingga laporan dinonaktifkan",
  no_files: "tidak ada file",
  no_lyrics: "tidak ada lirik",
  no_member_reports: "laporan anggota tidak tersedia",
  no_parties_found: "tidak ada pihak yang ditemukan",
  no_payments_for_you: "Anda tidak berhak atas pembayaran apa pun dalam siklus distribusi ini, sehingga laporan dinonaktifkan",
  no_performers_for_this_work: "tidak ada pemain yang dinyatakan untuk karya ini.",
  no_qa_reports: "Laporan QA tidak tersedia",
  no_shares: "tidak ada saham",
  no_sources_found: "tidak ada sumber yang ditemukan untuk karya ini",
  no_stats_info_available: "tidak ada statistik yang tersedia",
  no_work_report: "laporan lagu tidak tersedia",
  non_ipi: "non IPI",
  not_current: "tidak saat ini",
  nothing_has_been_selected: "tidak ada yang dipilih",
  nothing_to_display: "nothing to display",
  on: "pada",
  only_alpha_numeric_characters_allowed: "hanya karakter numerik alfa yang diperbolehkan",
  only_domestic: "hanya lagu domestik",
  only_with_usages: "hanya dengan usages/penggunaan",
  original: "asli",
  original_lyrics: "lirik asli",
  original_music: "musik asli",
  original_publisher: "Penerbit Asli",
  original_sound_track: "trek suara asli",
  original_title: "judul asli",
  original_title_translated: "judul asli diterjemahkan",
  other_reference: "Referensi Lain",
  override_distribution: "menimpa distribusi",
  overview: "gambaran umum",
  own_works: "karya sendiri",
  part_title: "judul bagian",
  parties: "pihak-pihak",
  party: "pihak",
  password: "kata sandi",
  patronym: "Patronim",
  payees: "penerima pembayaran",
  pending: "tertunda",
  pending_allocation: "alokasi yang tertunda",
  pending_for_validation: "menunggu validasi",
  pending_updates: "pembaruan yang tertunda",
  per_and_mec: "PER dan MEC",
  per_duration: "per durasi",
  per_play: "per permainan",
  per_weighted_play: "per permainan berbobot",
  percent: "persen",
  performer: "pemain",
  performers: "pemain",
  performing: "melakukan",
  period: "periode",
  play_count: "hitungan bermain",
  plays: "bermain",
  please_check_your_inbox: "tolong, periksa kotak masuk Anda",
  pool: "kolam renang",
  pool_must_be_created_before_attaching: "kumpulan distribusi harus dibuat sebelum melampirkan file pro-rata",
  pools: "kolam renang",
  preferred: "lebih disukai",
  preferred_iswc: "iswc yang disukai",
  primary: "primer",
  primary_address: "alamat utama",
  primary_email: "email utama",
  primary_phone: "telepon utama",
  priority: "prioritas",
  privacy_policy: "kebijakan privasi",
  pro_rata_equal: "pro-rata - sama",
  pro_rata_file_deleted: "file pro-rata berhasil dihapus",
  pro_rata_percentage: "pro-rata - % per penerima pembayaran",
  processing: "pengolahan",
  processing_crd_reports: "memproses laporan CRD",
  products_not_found: "tidak ada rekaman yang dinyatakan untuk karya ini.",
  pronto_pre_distribution: "pra-distribusi pronto",
  proprietary_id: "id kepemilikan",
  pseudonym_groups: "Grup Nama Samaran",
  pseudonym_of_individuals: "Nama Samaran Individu",
  public_domain: "domain publik",
  publish: "menerbitkan",
  publish_distribution: "mempublikasikan distribusi",
  published: "diterbitkan",
  published_date: "tanggal diterbitkan",
  publisher: "penerbit",
  publisher_name: "nama penerbit",
  publisher_roles: "peran penerbit",
  qa_reports: "Laporan QA",
  queued_for_processing: "ditambahkan ke antrian pemrosesan",
  radio: "radio",
  reason: "alasan",
  reconciled: "didamaikan",
  reconciliation: "rekonsiliasi",
  recording: "perekaman",
  recording_conflict: "merekam konflik",
  recording_conflict_help_text: "Rekaman di atas saat ini ditautkan ke karya-karya berikut ini. Pilih satu karya, dan karya tersebut akan dihapus dari yang lainnya.",
  recording_conflicts: "merekam konflik",
  recording_details: "detail rekaman",
  recording_release: "rilis rekaman",
  recording_successfully_created: "rekaman berhasil dibuat",
  recording_successfully_linked: "rekaman berhasil ditautkan",
  recording_successfully_unlinked: "rekaman berhasil diputuskan tautannya",
  recording_title: "judul rekaman",
  recording_type: "jenis rekaman",
  recordings: "rekaman",
  refresh: "menyegarkan",
  register: "daftar",
  remitting_society_distribution_identifier: "mengirimkan id distribusi masyarakat",
  remove: "hapus",
  repertoire_admin: "admin repertoar",
  replaced_lyrics: "mengganti lirik",
  report_generation_confirmation: "konfirmasi pembuatan laporan",
  report_generation_has_successfully_been_initiated: "pembuatan laporan telah berhasil dimulai",
  request_changes: "meminta perubahan",
  request_member_reports: "meminta laporan anggota",
  request_bulk_member_reports: "meminta laporan seluruh anggota",
  request_reports_success: "Laporan telah diminta dan akan dikirim ke kotak masuk Anda segera setelah siap",
  request_sent: "Permintaan terkirim, laporan akan segera tersedia",
  request_work_report: "meminta laporan lagu",
  requested_by: "diminta oleh",
  reset_password: "setel ulang kata sandi",
  resolution: "resolusi",
  resolved_by: "diselesaikan oleh",
  restricted_title: "judul terbatas",
  right_types: "tipe yang tepat",
  rights: "hak",
  ring_back_tone: "nada dering kembali",
  role: "peran",
  rule: "aturan",
  rules: "aturan",
  rules_change_warning: "Perubahan aturan ini akan melepaskan semua file yang dilampirkan ke pool. Apakah Anda ingin melanjutkan",
  save: "simpan",
  search: "pencarian",
  search_and_select: "cari dan pilih",
  search_by: "cari berdasarkan",
  search_by_artist: "artis",
  search_by_atlas_id: "ID Atlas",
  search_by_filename: "nama file",
  search_by_ipi_number: "dengan nomor IPI",
  search_by_iswc_atlas_id_or_work_code: "ISWC, ATLAS ID, Mis@Asia atau DIVA",
  search_by_name: "nama",
  search_by_name_or_code: "Nama atau Kode",
  search_by_name_or_complete_ipi_number: "Nama atau Nomor IPI Lengkap",
  search_by_party_id: "ID Partai",
  search_by_party_name: "Nama Komposer atau Penerbit",
  search_by_party_number: "nomor partai",
  search_by_performer: "Nama Pemain atau Nama Artis",
  search_by_title: "judul",
  search_by_title_or_alternate_titles: "Judul Asli atau Alternatif",
  search_existing_works: "mencari karya yang sudah ada",
  search_ipi_db: "Cari Basis Data IPI",
  search_non_ipi_parties: "Cari Pihak Non-IPI",
  search_noun: "pencarian",
  search_results: "hasil pencarian",
  secondary_email: "email sekunder",
  secondary_phone: "telepon sekunder",
  select_agreement: "pilih agreement",
  select_candidate: "pilih kandidat",
  select_date_range: "pilih rentang tanggal",
  select_option: "pilih opsi",
  select_priority: "pilih prioritas",
  select_product_type: "pilih jenis produk",
  select_recording_type: "pilih jenis perekaman",
  select_this_work: "pilih karya ini",
  select_use_type: "pilih jenis penggunaan",
  selected: "dipilih",
  selected_files: "file yang dipilih",
  sender: "pengirim",
  sender_currency: "mata uang pengirim",
  server_error_message: "terjadi kesalahan, silakan hubungi administrator.",
  service: "layanan",
  set_as_preferred_iswc: "tetapkan sebagai iswc pilihan",
  share: "Bagikan",
  shares: "saham",
  show_distribution: "menunjukkan kunci distribusi",
  show_members_only: "tampilkan anggota saja",
  show_non_ipi_only: "Hanya menampilkan non IPI",
  show_source_metadata: "tampilkan metadata sumber",
  signup_confirmation: "Anda telah berhasil mendaftar. kami sedang meninjau aplikasi Anda. harap tunggu sampai akun Anda diaktifkan.",
  single_view_ingestion: "konsumsi tampilan tunggal",
  society: "masyarakat",
  society_admin: "admin masyarakat",
  sound_recording: "rekaman suara",
  source: "sumber",
  sources: "sumber",
  specific: "spesifik",
  split: "perpecahan",
  standardized_spelling: "Ejaan Standar",
  start: "mulai",
  start_date: "tanggal mulai",
  stats: "statistik",
  status: "status",
  sub_arranger: "Sub Arranger",
  sub_author: "Sub Penulis",
  submit_for_review: "kirimkan untuk ditinjau",
  submitted_by: "diajukan oleh",
  substituted_publisher: "Penerbit Pengganti",
  synchronisation: "sinkronisasi",
  tag_filters: "filter tag",
  tagging_was_successful: "penandaan berhasil dilakukan",
  termination_date: "tanggal penghentian",
  territories: "wilayah",
  territory: "wilayah",
  the_following_errors_have_to_fixed_for_allocation_to_run: "kesalahan berikut ini harus diperbaiki agar alokasi dapat berjalan",
  this_field_confirm_does_not_match: "konfirmasi bidang ini tidak cocok",
  this_field_is_required: "bidang ini wajib diisi",
  this_field_must_be_a_valid_email: "bidang ini harus berupa email yang valid",
  title: "judul",
  to: "untuk",
  total: "total",
  total_unique: "total unik",
  transaction: "transaksi",
  translated_lyrics: "lirik yang diterjemahkan",
  translator: "Penerjemah",
  tv: "TV",
  type: "jenis",
  unallocated: "tidak terisi",
  undo_allocation: "batalkan alokasi",
  undo_allocation_success: "membatalkan keberhasilan alokasi",
  unlink: "buka tautan",
  unmatch: "unmatch",
  unmatch_confirmation: "konfirmasi ketidakcocokan",
  unmatched: "tak tertandingi",
  unspecified: "tidak ditentukan",
  up1_report_confirmation: "laporan untuk file-file berikut akan dibuat dan tautan untuk mengunduh laporan akan dikirim ke alamat email ini",
  update: "pembaruan",
  update_user: "perbarui pengguna",
  upload: "unggah",
  upload_date: "tanggal pengunggahan",
  upload_exclusion_file: "upload exclusion file",
  upload_pro_rata_file: "unggah file pro-rata",
  uploaded_by: "diunggah oleh",
  uploader: "pengunggah",
  usage_file_successfully_marked_for_deletion: "file penggunaan berhasil ditandai untuk dihapus",
  usage_files: "file penggunaan",
  usage_period: "periode penggunaan",
  usage_successfully_matched: "penggunaan berhasil dicocokkan",
  usage_successfully_unmatched: "penggunaan berhasil tak tertandingi",
  usages_matching: "pencocokan penggunaan",
  use_type: "jenis penggunaan",
  user: "pengguna",
  user_action: "tindakan pengguna",
  user_actions: "tindakan pengguna",
  user_email: "email pengguna",
  user_email_field_help_text: "email ini akan digunakan untuk masuk ke aplikasi",
  user_name: "nama pengguna",
  user_name_field_help_text: "nama ini mengidentifikasi pengguna yang dapat masuk ke aplikasi",
  user_updated: "pengguna diperbarui",
  user_with_provided_email_doesnt_exist: "pengguna dengan email yang diberikan tidak ada",
  users: "pengguna",
  view: "melihat",
  view_in_works_database: "lihat di basis data karya",
  view_user_action: "melihat tindakan pengguna",
  view_work: "lihat lagu",
  vod_files: "File VOD",
  vod_pool: "VOD Pool",
  warning: "peringatan",
  week: "minggu",
  wex_remitted_royalty_amount: "Jumlah royalti yang dikirimkan WEX",
  which_work_do_you_want_to_keep: "lagu mana yang ingin Anda pertahankan",
  with_up: "mengalokasikan ke UP",
  without_up: "jangan alokasikan ke UP",
  work: "lagu",
  work_code: "kode lagu",
  work_codes: "kode lagu",
  work_detail: "detail lagu",
  work_edit_to_be_reviewed: "permintaan perubahan Anda telah berhasil dikirimkan, dan akan diverifikasi oleh admin.",
  work_id: "ID Lagu",
  work_matching: "pencocokan lagu",
  work_matching_stats: "statistik pencocokan lagu",
  work_registration: "pendaftaran lagu",
  work_registration_conflict: "pendaftaran lagu ini berpotensi duplikat, klik tautan untuk membuka halaman tindakan pengguna.",
  work_registration_created: "karya lagu berhasil dibuat, klik tautan di bawah ini untuk melihat detailnya.",
  work_registration_details: "detail pendaftaran lagu",
  work_registration_linked: "pendaftaran karya lagu ini diidentifikasi sebagai duplikat dan ditautkan ke lagu yang sudah ada, klik tautan untuk melihat detailnya.",
  work_registration_to_be_reviewed: "pendaftaran lagu Anda telah berhasil dikirimkan, dan akan diverifikasi oleh admin komunitas Anda.",
  work_report: "laporan lagu",
  work_selected: "lagu yang dipilih",
  work_successfully_created: "karya berhasil dibuat",
  work_successfully_deleted: "lagu berhasil dihapus",
  work_successfully_demerged: "lagu berhasil diturunkan",
  work_successfully_updated: "lagu berhasil diperbarui",
  work_title: "judul lagu",
  work_type: "jenis lagu",
  work_update_accepted: "pembaruan lagu diterima",
  work_update_declined: "pembaruan lagu ditolak",
  work_updates: "pembaruan lagu",
  works: "lagu",
  works_list_for_party_will_be_emailed: "Sebuah file yang berisi semua karya untuk pihak ini sedang dibuat dan tautan untuk mengunduh akan dikirim melalui email setelah siap.",
  works_list_for_you_will_be_emailed: "Sebuah file yang berisi semua karya Anda sedang dibuat dan tautan untuk mengunduh akan dikirim melalui email setelah siap.",
  works_matching: "pencocokan karya",
  works_search_by: "mencari di dalam karya penerbit berdasarkan judul, judul alternatif, atau iswc",
  works_single_view: "lagu dengan tampilan tunggal",
  works_successfuly_merged: "karya lagu berhasil digabungkan",
  works_with_non_ipi_ips: "lagu dengan IP non-IPI",
  wrong_role_for_party: "peran yang salah untuk pihak",
  yes: "Ya.",
  your_email: "email Anda",
}
